<div class="container-fluid register-container p-0 m-0" [@routerTransition]>
  <div class="d-flex p-0 m-0">
    <div class="full-height left-content" *ngIf="!isPopup">
      <div class="left-content-section h-100">
        <h2 class="header">Free electrical design calculators</h2>
        <p class="line-text-20">Cloud-based electrical calculations and design software for free.</p>
        <div class="text-section mobile-hide">
          <p class="line-text">With your free account, you get:</p>
          <ul class="checked-list">
            <li><i class="fa fa-check"></i>Cable sizing to AS/NZS 3008.1, BS 7671, IEC 60364-5-52, or NFPA-70 (NEC).</li>
            <li><i class="fa fa-check"></i> Maximum demand and low-voltage designs with switchboards in compliance with standards.</li>
            <li><i class="fa fa-check"></i> Protection coordination with time-current curves, arc flash (IEEE 1584), and cable pulling.</li>
            <li><i class="fa fa-check"></i> Video tutorials and product tours.</li>
          </ul>
        </div>
        <div class="text-section mobile-hide">
          <p class="line-text">Premium features include:</p>
          <ul class="checked-list">
            <li><i class="fa fa-check"></i> Manufacturer devices (Schneider, Eaton, ABB, Hager, NHP, LS, Siemens, and more).</li>
            <li><i class="fa fa-check"></i> Transformers, generator supplies, and extra calculators (voltage rise, cable schedules).</li>
            <li><i class="fa fa-check"></i> Premium reports with your logo + Excel add-in for cable sizing.</li>
            <li><i class="fa fa-check"></i> Downloadable standards and live chat support.</li>
          </ul>
        </div>
        <p class="line-text-18 support-number">Need support? Call us at <a href="tel:{{phoneNumber}}">
            {{phoneNumber}}</a></p>
        <div class="mobile-hide text-center">
          <img src="assets/cablepro/img/register-image.png" class="register-image" style="width:610px;">
          <div class="cplp_clients-intro text-center mb-3">

          </div>
          <div class="container margin-top-30">
            <h3 class="wow fadeInDown">Trusted by thousands of companies including</h3>
            <div class="row align-center company-imgs">
              <img class="trusted-by" src="assets/anonymouspage/icons/elek-client-AGL.jpg" alt="AGL" />
              <img class="trusted-by" src="assets/anonymouspage/icons/elek-client-Laser-Electrical.jpg"
                alt="Laser Electrical" />
              <img class="trusted-by" src="assets/anonymouspage/icons/elek-client-Stowe.jpg" alt="Stowe" />
              <img class="trusted-by" src="assets/anonymouspage/icons/elek-client-TafeNSW.jpg" alt="TAFE NSW" />
              <img class="trusted-by" src="assets/anonymouspage/icons/elek-client-engie-desa.jpg" alt="Engie Desa" />

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="align-items-center justify-content-center full-height right-text-only text-center right-content" [ngClass]="{'center-register-content-popup': isPopup == true}">
      <div class="center-content" [ngStyle]="{'height': isPopup ? 'auto' : '95vh'}">
        <!-- Main title for modal -->
        <h3 *ngIf="isPopup" class="text-center modal-title">Create Your Free Account</h3>

        <!-- Value prop subheading for modal -->
        <p *ngIf="isPopup" class="text-center modal-value-prop">Save calculations, generate PDF reports, and access all professional calculators</p>

        <!-- Non-popup header -->
        <a *ngIf="!isPopup" [routerLink]="['/']" class="modal-logo-link"><img src="assets/cablepro/img/logo.png" width="182" height="31" alt=""
            class="logo" /></a>
        <p *ngIf="!isPopup" class="maintext mb-3">Create your free account</p>
        <div class="w-100 login-controls modal-login-controls">
          <form id="register-form" #registerForm="ngForm" class="m-login__form m-form register-form" method="post"
            novalidate (ngSubmit)="save(registerForm)">
            <div class="control">
              <input #nameInput="ngModel" class="form-input" autoFocus type="text" placeholder="Full name"
                [(ngModel)]="model.name" name="Name" required maxlength="32" />
              <validation-messages *ngIf="submitted" class="text-left" [formCtrl]="nameInput"
                [ignoreDirty]="true"></validation-messages>
            </div>
            <div class="control">
              <input #emailAddressInput="ngModel" class="form-input" type="form-input" placeholder="Work email"
                [(ngModel)]="model.emailAddress" name="EmailAddress" required maxlength="256" email />
              <validation-messages *ngIf="submitted" class="text-left" [formCtrl]="emailAddressInput"
                [ignoreDirty]="true" [errorDefs]="[{email: l('InvalidEmailAddress')}]"></validation-messages>
            </div>
            <div class="control">
              <input type="password" name="Password" class="form-input" [(ngModel)]="model.password" #Password="ngModel"
                placeholder="{{l('Password')}}" reverse="true" [requireDigit]="passwordComplexitySetting.requireDigit"
                [requireLowercase]="passwordComplexitySetting.requireLowercase" maxlength="32"
                [requireUppercase]="passwordComplexitySetting.requireUppercase"
                [requireNonAlphanumeric]="passwordComplexitySetting.requireNonAlphanumeric"
                [requiredLength]="passwordComplexitySetting.requiredLength" required>
              <div [hidden]="registerForm.form.valid || registerForm.form.pristine" *ngIf="submitted"
                class="passwordmessage errormsg text-left">
                <ul class="help-block text-danger mt-1" *ngIf="Password.errors">
                  <li [hidden]="!Password.errors.required">
                    {{l("ThisFieldIsRequired")}}</li>
                  <li [hidden]="!Password.errors.requireDigit">
                    {{l("PasswordComplexity_RequireDigit_Hint")}}</li>
                  <li [hidden]="!Password.errors.requireLowercase">
                    {{l("PasswordComplexity_RequireLowercase_Hint")}}</li>
                  <li [hidden]="!Password.errors.requireUppercase">
                    {{l("PasswordComplexity_RequireUppercase_Hint")}}</li>
                  <li [hidden]="!Password.errors.requireNonAlphanumeric">
                    {{l("PasswordComplexity_RequireNonAlphanumeric_Hint")}}</li>
                  <li [hidden]="!Password.errors.requiredLength">
                    {{l("PasswordComplexity_RequiredLength_Hint",
                    passwordComplexitySetting.requiredLength)}}</li>
                </ul>
              </div>
            </div>
            <div class="w-100">
              <a id="aUserRegistration" class="d-none" href="javascript:void(0)"
                onClick="gtag('event', 'click', { event_category: 'User Registration', event_action: 'SignUp', event_label: 'Submit'});"></a>
              <!-- <button type="submit" class="btn btn-custom btn-blue mb-0" [disabled]="submitting">{{isWebFacing ? 'Create account':'Start my Free plan'}}</button> -->
              <button type="submit" class="btn btn-custom btn-blue mb-0" [disabled]="submitting">Create Account</button>
            </div>
          </form>
          <div class="signin-other-title">
            <h5 class="fs-13 title mb-0">OR</h5>
          </div>
          <div class="w-100">
            <div class="btn-group-vertical">
              <button class="btn btn-custom" [disabled]="!authLibraryReady || submitting" (click)="signUpWithGoogle()">
                <div>
                  <img width="24" height="24" src="assets/cablepro/img/google.svg" loading="lazy" alt="Google logo">
                  <span> Sign up with Google</span>
                </div>
              </button>
              <!-- <button class="btn btn-custom" [disabled]="!authLibraryReady || submitting" (click)="signUpWithFacebook()">
                <div>
                  <img width="24" height="24" src="assets/cablepro/img/facebook.svg" loading="lazy"
                    alt="Facebook logo">
                  <span> Sign up with Facebook</span>
                </div>
              </button> -->
            </div>
          </div>
          <!-- Reassurance text for modal -->
          <p *ngIf="isPopup" class="text-center modal-reassurance-text">
            No credit card is required. Free plan does not expire.
          </p>
          <!-- Divider before login link -->
          <div *ngIf="isPopup" class="modal-bottom-divider"></div>
          <div class="text-center">
            <a href="javascript:void(0);" (click)="onLogin()" id="forget-password" class="smalltext text-center login-link">Already have an account? Log in</a>
          </div>
        </div>
        <div class="text-center footer-area" *ngIf="!isPopup">
          <div class="footer-text">Software from <a href="https://elek.com" target="_blank"
              class="default-color">elek.com</a>
            <div class="ml-3 terms-privacy"><a class="cplp_f-legal m-2" href="https://elek.com/privacy"
                target="_blank">Privacy Policy</a> | <a class="cplp_f-legal m-2" href="https://elek.com/terms"
                target="_blank">Terms of Use</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>